import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { TagService } from './tag.service';

export const Ng1TagModule = angular
  .module('control-room.commons.services.tag', [])
  .factory('crTagService', downgradeInjectable(TagService));
